'use clinet'

import SectionTitle from "@/components/etc/section_title";
import api from "@/util/api";
import { useRouter } from "next/navigation";
import { useContext, useEffect, useRef, useState } from "react";
import ListV2 from "@/components/board/list_v2"
import { useLocale, useTranslations } from "next-intl";

import { DeviceContext } from "@/context/deviceContext";
import SlideText from "@/components/etc/SlideText";
import LocaleFormat from "@/components/etc/localeFormat";

export default function SportsAnalysisRanding() {
    const [listSportsAnalysis, setListSportsAnalysis] = useState<any[]>([])

    const router = useRouter()
    const locale = useLocale();
    const t = useTranslations('PageTitle')
    
    const fetchData = async () => {
        api(`/api/analysis/?page_count=6&page=1`)
            .then(res => res.json())
            .then(({ data }) => {
                setListSportsAnalysis(data?.posts ?? []);
            })
    };
    function setContentfunc(id :number){
        router.push(`/sportsanalysis/?id=${id}`)
    }

    useEffect(()=> {
        fetchData()
    }, [])

    return (
        <div className="p-r-5 p-l-5">
            <SectionTitle shortCut={`/sportsanalysis/`} type="sports-analysis" >{t.rich('스포츠 b:분석', { b: (chunks)=> <b>{chunks}</b> })}</SectionTitle>
            <ListV2 list={listSportsAnalysis} 
                    setContent={setContentfunc} 
                    className={`sports-analysis-list-new p-t-0`}
                    customStyle={{margin:"0", paddingBottom:0}}>
                {(list: any, idx: number) => (
                    <>
                        <div className={`date`}><LocaleFormat date={list.game_time} format="MMM DD (ddd) HH:mm" /></div>

                        <div className={`home box w-40-per`}>
                            <div className={`img`}>
                                {
                                    list.home_team_logo
                                        ? <img className="team-amb" 
                                                src={list.home_team_logo} 
                                                alt=""
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null;
                                                    e.currentTarget.src = `${require('@/public/image/etc/LogoA.png').default.src}`; 
                                                }} />
                                        : <img className="team-amb" src={require(`@/public/image/etc/LogoA.png`).default.src} alt="" />
                                }
                            </div>
                            <div className={`text`}>
                                <div>
                                    {(() => {
                                        const homeTeam = list.home_team || '';
                                        const len = Array.from(homeTeam).length;
                                        const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.7)));
                                        return <div style={{ fontSize: `${fontSize}px` }}>{homeTeam}</div>;
                                    })()}
                                    {/* {list.home_team} */}
                                </div>
                                <div className={`font-12`}>{list.home_info}</div>
                            </div>
                        </div>

                        <div className={`vs`}>VS</div>

                        <div className={`away box w-40-per`}>
                            <div className={`img`}>
                                {
                                    list.away_team_logo
                                        ? <img className="team-amb" 
                                                src={list.away_team_logo} 
                                                alt=""
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null;
                                                    e.currentTarget.src = `${require('@/public/image/etc/LogoB.png').default.src}`; 
                                                }} />
                                        : <img className="team-amb" src={require(`@/public/image/etc/LogoB.png`).default.src} alt="" />
                                }
                            </div>
                            <div className={`text`}>
                                <div>
                                    {(() => {
                                        const homeTeam = list.away_team || '';
                                        const len = Array.from(homeTeam).length;
                                        const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.7)));
                                        return <div style={{ fontSize: `${fontSize}px` }}>{homeTeam}</div>;
                                    })()}
                                    {/* {list.away_team} */}
                                </div>
                                <div className={`font-12`}>{list.away_info}</div>
                            </div>
                        </div>
                        {(() => {
                            const league = list.league_name || '';
                            const len = Array.from(league).length;
                            const fontSize = Math.max(12, Math.min(16, Math.round(20 - len * 0.5)));
                            return (
                                <ETC league={league} fontSize={fontSize} />
                            )
                        })()}
                        {/* <div className={`etc`}>{list.league_name}</div> */}
                    </>
                )}
            </ListV2>
           
        </div>
    )
}


function ETC({ league, fontSize }: { league: string, fontSize: number }) {
    const [contentEl, setContentEl] = useState<HTMLDivElement | null>(null)
    return (
        <div className="etc" style={{ fontSize: `${fontSize}px` }} ref={setContentEl}>
            <SlideText coverEl={contentEl} fontSize={14} text={league} />
        </div>
    )
}
